import { jsx as _jsx } from "react/jsx-runtime";
import { listDict } from '../../../constants';
import classes from '../EditSidePage.module.css';
export const ErrorMessage = ({ isEditPage, listType }) => {
    const text = isEditPage ? 'Не удалось сохранить изменения. Попробуйте ещё раз' : listDict[listType].createError;
    return _jsx("span", { className: classes.errorRow, children: text });
};
